import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useStyles = makeStyles({
  wrapper: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    alignItems: "center",
    overflowY: "auto",
    backgroundColor: designTokens.neutral[50],
    fontFamily: designTokens.fontFamily,
    color: designTokens.neutral[700],
    padding: `${designTokens.spacing[10]} ${designTokens.spacing[6]}`,
    "@media (max-width: 480px)": {
      padding: `${designTokens.spacing[5]} ${designTokens.spacing[4]}`,
    },
  },
  card: {
    backgroundColor: designTokens.neutral.white,
    borderRadius: designTokens.borderRadius.xl,
    boxShadow: designTokens.shadow.md,
    maxWidth: "600px",
    width: "100%",
    boxSizing: "border-box",
    padding: `${designTokens.spacing[10]} ${designTokens.spacing[10]} ${designTokens.spacing[8]}`,
    position: "relative",
    margin: "auto",
    "@media (max-width: 480px)": {
      padding: `${designTokens.spacing[6]} ${designTokens.spacing[4]}`,
      borderRadius: designTokens.borderRadius.lg,
    },
  },
  title: {
    fontSize: designTokens.fontSize["2xl"],
    fontWeight: designTokens.fontWeight.bold,
    color: designTokens.primary[900],
    marginBottom: designTokens.spacing[4],
    lineHeight: `${designTokens.lineHeight.tight}`,
    marginTop: "0",
    "@media (max-width: 480px)": {
      fontSize: designTokens.fontSize.xl,
    },
  },
  paragraph: {
    fontSize: designTokens.fontSize.sm,
    lineHeight: `${designTokens.lineHeight.relaxed}`,
    marginBottom: designTokens.spacing[6],
    marginTop: "0",
  },
  sectionTitle: {
    fontSize: designTokens.fontSize.sm,
    fontWeight: designTokens.fontWeight.bold,
    marginBottom: designTokens.spacing[3],
    marginTop: "0",
  },
  bulletList: {
    paddingLeft: designTokens.spacing[5],
    marginBottom: designTokens.spacing[6],
    marginTop: "0",
  },
  listItem: {
    fontSize: designTokens.fontSize.sm,
    lineHeight: `${designTokens.lineHeight.relaxed}`,
    marginBottom: designTokens.spacing[2],
  },
  divider: {
    border: "none",
    borderTop: `1px solid ${designTokens.neutral[200]}`,
    margin: `${designTokens.spacing[6]} 0 ${designTokens.spacing[4]}`,
  },
  linksSection: {
    fontSize: designTokens.fontSize.sm,
    lineHeight: `${designTokens.lineHeight.relaxed}`,
    marginBottom: designTokens.spacing[6],
  },
  footer: {
    display: "flex",
    justifyContent: "center",
  },
  continueButton: {
    minWidth: "120px",
  },
});
